var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrototyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    transform: "translate(-6269 -2851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M6288.264,2863.425v-4c3.275-1.411.246-5.844-2.085-3.34l-4.206-1.78a2.149,2.149,0,0,0-.256-1.363,1.989,1.989,0,0,0-3.689,1.3l-4.386,2.218c-2.67-2.11-4.877,2.4-1.909,3.53v4.019c-3.2,1.353-.385,5.758,2.019,3.417l4.289,2.248a2.006,2.006,0,1,0,3.9-.165l4.379-2.6c2.651,2.2,4.952-2.344,1.948-3.492Zm-1.586.206a2.123,2.123,0,0,0-.921,2.258l-4.394,2.607a1.948,1.948,0,0,0-.8-.475v-4.438a2.1,2.1,0,0,0,1.413-2.34l4.4-2.254a1.974,1.974,0,0,0,.754.437v4a1.986,1.986,0,0,0-.45.207Zm-7.51-2.256a.864.864,0,1,1,1.672.436A.864.864,0,1,1,6279.168,2861.375Zm8.092-4.714c1.018-.571,1.8.942.872,1.544C6287.077,2858.771,6286.35,2857.258,6287.26,2856.661Zm-1.537.509a2.164,2.164,0,0,0,.052.808l-4.306,2.206a1.966,1.966,0,0,0-2.973.05l-4.219-1.989a2.17,2.17,0,0,0-.049-.761l4.248-2.147a1.951,1.951,0,0,0,3.02.044Zm-6.155-3.938a.851.851,0,0,1,1.171.313c.667,2.315-2.808,1.215-1.171-.313Zm-8,5.232a.867.867,0,1,1,1.47-.919A.867.867,0,1,1,6271.566,2858.464Zm1.171,8.318a.887.887,0,0,1-.872-1.544C6272.9,2864.667,6273.659,2866.188,6272.737,2866.782Zm1.522-.407a2.109,2.109,0,0,0-1.39-2.357V2860a2.055,2.055,0,0,0,.963-.665l4.194,1.976a2.1,2.1,0,0,0,1.4,2.265v4.453a2.038,2.038,0,0,0-.893.589Zm6.181,4.414c-1.054.565-1.782-.947-.871-1.545C6280.6,2868.674,6281.364,2870.194,6280.44,2870.789Zm7.692-4.6a.887.887,0,0,1-.872-1.544C6288.291,2864.075,6289.055,2865.6,6288.132,2866.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 22,
    height: 22,
    transform: "translate(6269 2851)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrototyping);
export default __webpack_public_path__ + "static/media/icon-prototyping.7de5664b54d0a253b389f8d4f95c75a5.svg";
export { ForwardRef as ReactComponent };